import type { DataGetter } from '@rea-argonaut/analytics';
import { trackEvent } from '@rea-argonaut/analytics';

export interface TrackOutboundLinkClick {
  outboundLinkType: string;
  url: string;
  schema?: string;
  event_name?: string;
}

export interface OutboundTrackingEventData {
  schema: string;
  data: {
    event_name: string;
    type: string;
    click_url: string;
  };
}

export const trackOutboundLinkClick = ({
  outboundLinkType,
  url,
  schema,
  event_name,
}: TrackOutboundLinkClick): void => {
  const event: DataGetter = () => ({
    schema: schema ?? 'iglu:au.com.property/pca_outbound_link_click/jsonschema/1-0-0',
    data: {
      event_name: event_name ?? 'pca_outbound_link_click',
      type: outboundLinkType,
      click_url: url,
    },
  });
  trackEvent(event);
};
